import { useState, useEffect, useRef } from "react";

export function useStickyFooter(isMobile) {
  const nextButtonAnchorRef = useRef(null);
  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    if (!isMobile) {
      setIsAtBottom(false);
      return;
    }

    const handleScroll = () => {
      if (!nextButtonAnchorRef.current) return;

      const rect = nextButtonAnchorRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      if (rect.top <= viewportHeight) {
        setIsAtBottom(true);
      } else {
        setIsAtBottom(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, [isMobile]);

  return { nextButtonAnchorRef, isAtBottom };
}
